// extracted by mini-css-extract-plugin
export default {"wrapper":"NotificationsManager_wrapper__bwBi4","hidden":"NotificationsManager_hidden__E2xQe"};